import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { IMAGES, scrollToBuy } from '../utils/constants';
const HIGHLIGHTS = ['1 Complete System', '5 Strategic Bonuses', '6 Full Modules'];
export function Hero() {
  return <header className="w-full bg-night" data-id="element-118" data-mp="9ipbpaa4vbzl">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-4 pb-6 pt-4 text-center sm:pt-6" data-id="element-119" data-mp="4m8mecr76rkx">
        <span className="font-head text-[10px] font-semibold uppercase tracking-[0.16em] text-cta sm:text-xs" data-id="element-120" data-mp="129qv5nkuztox">
          The complete professional system for Spanish teachers
        </span>

        <h1 className="mt-1.5 font-head text-[26px] font-bold uppercase leading-[0.95] text-white sm:text-[42px] lg:text-5xl" data-id="element-121" data-mp="saruosa8z4d0">
          Plan your next Spanish lesson with a{' '}
          <span className="text-cta" data-id="element-122" data-mp="3d1imxgffvoql">clear structure</span> — without starting from scratch.
        </h1>

        <p className="mt-2 max-w-2xl text-[12px] leading-snug text-silver sm:text-[15px]" data-id="element-123" data-mp="382p6bf4uvhm7">
          Your complete professional 6-in-1 teaching system: lesson planning, grammar resources,
          real-life vocabulary, speaking activities, ready-to-use classroom resources, student
          progression and assessment tools.
        </p>

        <button type="button" onClick={scrollToBuy} className="mt-1 block w-full max-w-2xl transition-opacity duration-150 ease-out hover:opacity-95" aria-label="Go to the purchase section" data-id="element-124" data-mp="399jmlbbyab52">
          <img src={IMAGES.system} alt="Spanish Teacher Pro complete system with six modules and five strategic bonuses" className="mx-auto w-full" loading="eager" data-id="element-125" data-mp="30gzuyuu2t6tq" />
        </button>

        <ul className="flex flex-wrap justify-center gap-x-2 gap-y-0.5 font-head text-[10px] font-semibold uppercase tracking-wide text-white sm:text-xs" data-id="element-126" data-mp="2qkd9q4xu8dr6">
          {HIGHLIGHTS.map((item, index) => <li key={item} className="flex items-center gap-2" data-id="element-127" data-mp="2hjf3dfzxfu5f" data-mpi={index}>
              {index > 0 && <span className="text-cta" aria-hidden="true" data-id="element-128" data-mp="2hljb690y5daz">·</span>}
              {item}
            </li>)}
        </ul>
        <p className="mt-0.5 text-[10px] font-semibold uppercase tracking-wide text-silver sm:text-[11px]" data-id="element-129" data-mp="s1rsopcm88ut">
          Spanish Teachers · Tutors · Online &amp; In-Person Instructors
        </p>

        <div className="mt-3 flex w-full flex-col items-center" data-id="element-130" data-mp="ibyqgeyd5638">
          <CtaButton data-id="element-131" data-mp="ici1dbpliu7r" />
          <TrustRow className="mt-1.5" data-id="element-132" data-mp="dd5dcnmznh3l" />
        </div>
      </div>
    </header>;
}